import { BUCKET_LIST_ACTIONS } from "constants";

export function fetchBucketCases(stageIds, type, pageNo, pageSize, stage, caseStatus, filters={}, documentFilter) {
    return {
        type: BUCKET_LIST_ACTIONS.FETCH_CASE_BUCKET_LIST,
        payload: {
            stageIds,
            type,
            pageNo,
            pageSize,
            stage,
            caseStatus,
            filters,
            documentFilter
        }
    };
}

export function fetchedBucketCases(stageIds, stage_type, page, cases, count, stage, type, filters) {
    return {
        type: BUCKET_LIST_ACTIONS.FETCHED_CASE_BUCKET_LIST,
        payload: {
            stageIds,
            stage_type,
            page,
            cases,
            count,
            stage,
            type,
            filters
        }
    };
}

export function failedFetchBucketCases(error) {
    return {
        type: BUCKET_LIST_ACTIONS.FAILED_FETCH_BUCKET_LIST,
        error
    };
}

export function assignBucketCases(caseId) {
    return {
        type: BUCKET_LIST_ACTIONS.ASSIGN_CASE_FROM_BUCKET,
        payload: {
            caseId
        }
    };
}

export function assignedBucketCases(caseId, data) {
    return {
        type: BUCKET_LIST_ACTIONS.ASSIGNED_CASE_FROM_BUCKET,
        payload: {
            caseId,
            data
        }
    };
}

export function failedAssignBucketCases(error) {
    return {
        type: BUCKET_LIST_ACTIONS.FAILED_ASSIGN_CASE_FROM_BUCKET,
        error
    };
}



export function proceedBucketCases(case_task_id, this_stage, remarks) {
    return {
        type: BUCKET_LIST_ACTIONS.PROCEED_BUCKET_CASE,
        payload: {
            case_task_id,
            this_stage,
            remarks
        }
    };
}

export function successProceedBucketCases(case_task_id, this_stage, data) {
    return {
        type: BUCKET_LIST_ACTIONS.SUCCESS_PROCEED_BUCKET_CASE,
        payload: {
            case_task_id,
            this_stage,
            data
        }
    };
}

export function failedProceedBucketCases(error) {
    return {
        type: BUCKET_LIST_ACTIONS.FAILED_PROCEED_BUCKET_CASE,
        error
    };
}

export function referBucketCases(case_task_id, this_stage, remarks) {
    return {
        type: BUCKET_LIST_ACTIONS.REFER_BUCKET_CASE,
        payload: {
            case_task_id,
            this_stage,
            remarks
        }
    };
}

export function successReferBucketCases(case_task_id, this_stage, data) {
    return {
        type: BUCKET_LIST_ACTIONS.SUCCESS_REFER_BUCKET_CASE,
        payload: {
            case_task_id,
            this_stage,
            data
        }
    };
}

export function failedReferBucketCases(error) {
    return {
        type: BUCKET_LIST_ACTIONS.FAILED_REFER_BUCKET_CASE,
        error
    };
}

export function bulkAssignBucketCases(caseTaskIds, thisUser, remarks=null, stageId, stageName) {
    return {
        type: BUCKET_LIST_ACTIONS.BULK_ASSIGN_CASE_FROM_BUCKET,
        payload: {
            caseTaskIds,
            thisUser,
            remarks,
            stageId,
            stageName
        }
    };
}

export function bulkAssignedBucketCases(caseTaskIds, data) {
    return {
        type: BUCKET_LIST_ACTIONS.BULK_ASSIGNED_CASE_FROM_BUCKET,
        payload: {
            caseTaskIds,
            data
        }
    };
}

export function failedBulkAssignBucketCases(error) {
    return {
        type: BUCKET_LIST_ACTIONS.FAILED_BULK_ASSIGN_CASE_FROM_BUCKET,
        error
    };
}